const logos = [
  {
    name: "Firecrawl",
    url: "/images/firecrawl.png",
  },
  {
    name: "Elevenlabs",
    url: "/images/11labs.png",
  },
  {
    name: "Make.com",
    url: "/images/make.png",
  },
  {
    name: "OpenAI",
    url: "/images/openai.png",
  },
  {
    name: "Stripe",
    url: "/images/stripe.png",
  },
  {
    name: "Gemini",
    url: "/images/gemini.png",
  },
];

const AnimatedLogoCloud = () => {
  return (
    <div className="w-full">
      <div className="mx-auto w-full px-4 md:px-8">
        <div
          className="group relative mt-6 flex overflow-hidden p-2"
          style={{
            maskImage:
              "linear-gradient(to left, transparent 0%, black 20%, black 80%, transparent 95%)",
          }}
        >
          {Array(5)
            .fill(null)
            .map((val, index) => (
              <div
                key={index}
                className="flex shrink-0 animate-logo-cloud flex-row justify-around gap-1"
              >
                {logos.map((logo, key) => (
                  <img
                    key={key}
                    src={logo.url}
                    className="h-16 w-fit"
                    alt={`${logo.name}`}
                  />
                ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default AnimatedLogoCloud;
